import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useUser } from '../UserContext'; // Import the useUser hook
import SupporterMenu from './SupporterMenu'; // Import the SupporterMenu component

const SettingsModal = ({ show, onClose, onSave }) => {
	
  const { user, settings, setSettings } = useUser();
	
  useEffect(() => {
    const savedMode = localStorage.getItem('darkMode') === 'true';
    document.body.classList.toggle('dark-mode', savedMode);
    setSettings((prevSettings) => ({
      ...prevSettings,
      darkMode: savedMode,
    }));
  }, []);

  const handleChange = (e) => {
	setSettings({
		...settings,
		[e.target.name]: e.target.value,
	});
  };

  const handleDarkModeToggle = () => {
    setSettings((prevSettings) => {
      const newDarkMode = !prevSettings.darkMode;
      document.body.classList.toggle('dark-mode', newDarkMode);
      localStorage.setItem('darkMode', newDarkMode);
      return {
        ...prevSettings,
        darkMode: newDarkMode,
      };
    });
  };


  const handleSave = () => {
    localStorage.setItem('cardsPerRow', settings.cardsPerRow);
    localStorage.setItem('language', settings.language);
    document.cookie = `language_creator=${encodeURIComponent(settings.language)}; path=/; max-age=31536000; SameSite=Strict`;
    document.cookie = `language_creator=${encodeURIComponent(settings.language)}; path=/gallery; max-age=31536000; SameSite=Strict`;
    onSave(settings);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="settings">
          <Form.Label>Cards per row (Mobile):</Form.Label>
          <Form.Control
            as="select"
			name="cardsPerRow"
            value={settings.cardsPerRow}
			className="form-select"
            onChange={handleChange}
          >
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
          </Form.Control>
        </Form.Group>
        <Form.Group controlId="language">
          <Form.Label>Language:</Form.Label>
          <Form.Control
            as="select"
			name="language"
            value={settings.language}
			className="form-select"
            onChange={handleChange}
          >
            <option value={'en'}>English</option>
            <option value={'ru'}>Русский</option>
          </Form.Control>
        </Form.Group>
        {/* <Form.Group controlId="darkMode">
          <Form.Label>Dark Mode:</Form.Label>
          <Form.Check
            type="switch"
            name="darkMode"
            checked={settings.darkMode}
            onChange={handleDarkModeToggle}
            label={settings.darkMode ? "On" : "Off"}
          />
        </Form.Group> */}
      <SupporterMenu />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SettingsModal;
